export enum AcademyStep {
  IntroVideo = 'introVideo',
  NavigationTour = 'navigationTour',
  SyncCalendar = 'syncCalendar',
  AdjustNotifications = 'adjustNotifications',
  FeaturePack = 'featurePack',
  EnableEEO = 'enableEeo',
  EnableGDPR = 'enableGdpr',
  EnableSSO = 'enableSso',
  CareersSiteDescription = 'careersSiteDescription',
  CareersSiteCustomize = 'careersSiteCustomize',
  PublishJobs = 'publishJobs',
  CreateJob = 'createJob',
  JobDescription = 'jobDescription',
  PromoteJobs = 'promoteJobs',
  SourceCandidates = 'sourceCandidates',
  SourcingExtension = 'sourcingExtension',
  TalentPools = 'talentPools',
  PipelineOverview = 'pipelineOverview',
  AutomatedActions = 'automatedActions',
  ImportCandidates = 'importCandidates',
  HiringRoles = 'hiringRoles',
  InviteTeamMembers = 'inviteTeamMembers',
  MobileAppDescription = 'mobileAppDescription',
  InstallMobileApp = 'installMobileApp',
  Integrations = 'integrations',
  Plan = 'plan',
}

export type QuickStartSteps = Record<AcademyStep, boolean>;
